import { call, put, takeEvery } from "redux-saga/effects";
import { callApi, callApiWithNoAuth, Method, request } from "../../api/Api";
import { getConfig } from "../../services/environment";
import { stopLoading,startLoading, showErrorMessage } from "../layout/action";
import {
  GET_REGISTER_WITHOUT_SESSION,
  GET_REGISTER_WITH_SESSION,
  setRegisterHtmlWithSession,
} from "./action";
import { setRegisterHtmlWithoutSession } from "./action";
import * as QueryParams from "query-string";
import { getCitationEnabled } from "../login/action";

export function* watchGetCustomerRegisterWithoutSession() {
  yield takeEvery(GET_REGISTER_WITHOUT_SESSION, function* ({ payload }) {
    try {

      const dataLocation = window.location.href
      let url = String(dataLocation)
      let getGroupname = (url) => {
        let f = url.split("/")
        let dats
        for (let i = 2; i < f.length; i++) {
          if (f[i] == "driverportal") {
            dats = f[i + 1]
          }
        }
        return dats
      }

      yield put(startLoading());
      // let data = {
      //   // client_id: getConfig.clientId,
      //   client_id: getGroupname(url) + "-token",
      //   client_secret: getConfig.clientSecret,
      //   grant_type: "password",
      //   password: getConfig.masterUserPassword,
      //   username: getConfig.masterUserName,
      // };
      // const responseLogin = yield call(request, {
      //   data: QueryParams.stringify(data),
      //   headers: {
      //     "Content-Type": "application/x-www-form-urlencoded",
      //   },
      //   method: "POST",
      //   url: `/auth/realms/${getGroupname(url)}/protocol/openid-connect/token`,
      //   // url: `/auth/realms/rpe2g/protocol/openid-connect/token`,
      // });
      // let responseData = responseLogin.data;
      const response = yield call(callApiWithNoAuth, {
        // headers: {
        //   Accept: "application/json",
        //   Authorization: `Bearer ${responseData["access_token"]}`,
        //   "Content-Type": "application/json",
        // },
        method: "GET",
        // url: `/api/v1/portal/pages/create-login/${payload}`,
        url: `/portal/pages/home-without-session/create-login/${payload}`,
      });

      yield put(
        setRegisterHtmlWithoutSession(response.data[0].text || { text: "" })
      );
      yield put(getCitationEnabled(payload));
      yield put(stopLoading());
    } catch (err) {
      yield put(stopLoading());
      // yield put(showErrorMessage({ error: err, title: "GET REGISTER HTML" }));
    }
  });
}
export function* watchGetCustomerRegisterWithSession() {
  yield takeEvery(GET_REGISTER_WITH_SESSION, function* ({ payload }) {
    try {
      const response = yield call(callApiWithNoAuth, {
        // url: `/portal/pages/create-login/${payload.customerName}`,
        url: `/portal/pages/home-without-session/create-login/${payload.customerName}`,
        method: Method.GET,
      });
      yield put(setRegisterHtmlWithSession(response.data[0] || { text: "" }));
    } catch (err) {
      yield put(stopLoading());
      // yield put(showErrorMessage({ error: err, title: "GET REGISTER HTML" }));
    }
  });
}
